module.exports = __webpack_public_path__ + "img/about.41448990.png";